export const styles = {
  today: 'Months_today',
  sunday: 'Months_sunday',
  weekend: 'Months_weekend',
  start: 'Months_start',
  end: 'Months_end',
  dayWithTooltip: 'Months_dayWithTooltip',
  fade_out: 'Months_fade_out',
  wrong: 'Months_wrong',
  focus: 'Months_focus',
} as const
